import { loan_application } from '@axo/shared/data-access/types';
import { getCountryOptions } from '../../../../utils/Norway/getCountryOptions';

export const STARTUP_FEE = 950;
export const MONTHLY_FEE = 30;
export const RATES = {
  LOW: 4.9,
  MID: 11.9,
  HIGH: 19.9,
} as const;

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DEFAULT_LOAN_DURATION = 5;
export const DEFAULT_LOAN_AMOUNT = 150_000;
export const MAX_LOAN_DURATION = 20;
export const MIN_LOAN_AMOUNT = 10_000;
export const MAX_LOAN_AMOUNT = 800_000;

export const PHONE_REGEX = /^\+?(00)?(47)?[49]\d{7}$/;

type OptionList<T> = { value: T; text: string }[];

export const radioOptions = [
  { text: 'yes', value: 'Yes' },
  { text: 'no', value: 'No' },
];

export const initialPurposeOptions: OptionList<loan_application.Purpose> = [
  { text: 'yes', value: loan_application.Purpose.RefinancingLoan },
  { text: 'no', value: loan_application.Purpose.Other },
];

export const citizenshipOptions = getCountryOptions();

export const employmentOptions: OptionList<loan_application.EmploymentStatus> =
  [
    {
      text: 'EmploymentStatus.Permanent',
      value: loan_application.EmploymentStatus.Permanent,
    },
    {
      text: 'EmploymentStatus.PermanentPublic',
      value: loan_application.EmploymentStatus.PermanentPublic,
    },
    {
      text: 'EmploymentStatus.Temporary',
      value: loan_application.EmploymentStatus.Temporary,
    },
    {
      text: 'EmploymentStatus.Entrepreneur',
      value: loan_application.EmploymentStatus.Entrepreneur,
    },
    {
      text: 'EmploymentStatus.Pensioner',
      value: loan_application.EmploymentStatus.Pensioner,
    },
    {
      text: 'EmploymentStatus.Disabled',
      value: loan_application.EmploymentStatus.Disabled,
    },
    {
      text: 'EmploymentStatus.Rehabilitation',
      value: loan_application.EmploymentStatus.Rehabilitation,
    },
  ];

export const educationOptions: OptionList<loan_application.Education> = [
  {
    text: 'yes',
    value: loan_application.Education.EducationHigherEducation,
  },
  {
    text: 'no',
    value: loan_application.Education.EducationHighSchool,
  },
];

export const maritalStatusOptions: OptionList<loan_application.MaritalStatus> =
  [
    {
      value: loan_application.MaritalStatus.Married,
      text: 'MaritalStatus.Married',
    },
    {
      value: loan_application.MaritalStatus.Single,
      text: 'MaritalStatus.Single',
    },
    {
      value: loan_application.MaritalStatus.Cohabiting,
      text: 'MaritalStatus.Cohabiting',
    },
  ];

export const amountOfChildrenOptions: OptionList<string> = [
  { value: '0', text: '0' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
  { value: '4', text: '4' },
  { value: '5', text: '5 eller fler' },
];

export const housingOptions: OptionList<loan_application.Residence> = [
  {
    value: loan_application.Residence.OwnApartment,
    text: 'HousingType.OwnApartment',
  },
  { value: loan_application.Residence.OwnHouse, text: 'HousingType.OwnHouse' },
  {
    value: loan_application.Residence.CooperativeApartment,
    text: 'HousingType.CooperativeApartment',
  },
  {
    value: loan_application.Residence.Rental,
    text: 'HousingType.Rental',
  },
];
